import {scriptonload} from '../modules/scriptonload';

var vk = function (el) {
	var init = function(){
		var uid = el.getAttribute('id');
		var param = JSON.parse(el.getAttribute('data-param'));
		var height = (param && param.height) ? param.height : 300;
		VK.Widgets.Group(uid, {mode: 0, width: "300", height: height, color1: '141414', color2: 'ffffff', color3: '5B7FA6'}, 52241390);
	};

	scriptonload('//vk.com/js/api/openapi.js', init);
};

export {vk};
